import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';

export const AdminBillingView: React.FC = () => {
    const [profiles, setProfiles] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.getAllBillingProfilesAdmin().then(setProfiles).catch(console.error).finally(() => setLoading(false));
    }, []);

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
                <h2 className="text-xl font-bold mb-4">All User Billing Profiles</h2>
                {loading ? <p>Loading...</p> : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm text-left">
                            <thead className="bg-slate-50 text-slate-500 font-bold">
                                <tr>
                                    <th className="p-3">User Email</th>
                                    <th className="p-3">Type</th>
                                    <th className="p-3">Name</th>
                                    <th className="p-3">VAT</th>
                                    <th className="p-3">Country</th>
                                    <th className="p-3">Tax Status</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {profiles.map((p, i) => (
                                    <tr key={i} className="hover:bg-slate-50">
                                        <td className="p-3">{p.userEmail}</td>
                                        <td className="p-3 capitalize">{p.type}</td>
                                        <td className="p-3 font-medium">{p.name}</td>
                                        <td className="p-3">{p.vatNumber || '-'} {p.vatValid ? '✅' : ''}</td>
                                        <td className="p-3">{p.country}</td>
                                        <td className="p-3 text-xs text-slate-500">{p.taxStatus}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};
